<div
  class="detail-overlay"
  role="dialog"
  tabindex="0"
  (click)="onClose()"
  (keydown.escape)="onClose()"
>
  <div
    class="detail-drawer"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown.escape)="onClose()"
  >
    <div class="detail-header">
      <h2>{{ 'auditLog.action.' + entry.action | transloco }}</h2>
      <htx-button variant="ghost" icon="close" [iconOnly]="true" (click)="onClose()"></htx-button>
    </div>
    <div class="detail-body">
      <htx-data-display [data]="displayData"></htx-data-display>

      @if (entry.details) {
        <div class="details-section">
          <h3>{{ 'auditLog.detail.title' | transloco }}</h3>
          <pre>{{ detailsJson }}</pre>
        </div>
      }
    </div>
  </div>
</div>
